import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import * as Yup from 'yup'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '../../product/context/product/productContext'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import AuthContext from '@/product/context/auth/authContext'
import { useFormik } from 'formik'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import BaseActionPage from '@/product/components/species/dynamic/common/BaseActionPage'
import UserContext from '@/product/context/user/userContext'
import Loaders from '@/product/components/molecules/Loaders'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import ProductContext from '@/product/context/userProduct/productContext'
import BuyerBids from './Tabs/BuyerBids'
import UserManage from './UserManage'
import UserInvoices from './Tabs/UserInvoices'
import LoginInfo from './Tabs/LoginInfo'
import Credits from './Tabs/Credits'
import UserEmailLogs from './Tabs/UserEmailLogs'
import UserNotifications from './Tabs/UserNotifications'
import UserBidHistory from './Tabs/UserBidHistory'
import { useHistory } from 'react-router-dom'
import UserSmsLogs from './Tabs/UserSmsLogs'
import Layout from '@/product/components/templates/Layout'
import UserNotes from './Tabs/UserNotes'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const BuyerFields = (props) => {
    const isFullScreen = false
    const userContext = useContext(UserContext)
    const userProductContext = useContext(ProductContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { allCountries, allStates } = useContext(ProductCommonContext)
    const authContext = useContext(AuthContext)
    const history = useHistory()
    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext

    const { search_alldashboardproducts, getAllDashboardProducts } =
        userProductContext

    const {
        user,
        loadUser,
        updateProfile,
        responseStatus: responseStatus,
    } = authContext

    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [buttonData, setButtonData] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])

    const [resetMapData, setResetMapData] = useState(false)

    const [tableValue, setTableValue] = useState([])
    const [action, setAction] = useState('')

    const [formikValues, setFormikValues] = useState({})
    const [array, setArray] = useState([])

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const queryParams = new URLSearchParams(window.location.search)
    const params = queryParams.get('tabs')

    const [value, setValue] = useState(0)

    const handleChange = (newValue) => {
        const urlSearchParams = new URLSearchParams(window.location.search)
        urlSearchParams.set('tabs', newValue)
        const newUrl = `${
            window.location.pathname
        }?${urlSearchParams.toString()}`
        window.history.pushState({ path: newUrl }, '', newUrl)

        setValue(newValue)
    }

    useEffect(() => {
        setValue(parseInt(params || 0, 10))
    }, [data?.popup, params])

    const notesValidation = Yup.object({
        reject_notes: Yup.string().required('Required'),
    })

    const notesFormik = useFormik({
        initialValues: {
            id: 0,
            email: '',
            reject_notes: '',
        },
        validationSchema: notesValidation,
        onSubmit: (values) => {
            userAction(values)
        },
    })

    const notesField = {
        formik: notesFormik,
        data: [
            {
                label: 'Notes',
                type: 'textarea',
                placeholder: 'Enter notes',
                class: 'col-12',
                name: 'reject_notes',
            },
        ],
    }

    useEffect(() => {
        if (single_user) {
            notesFormik.values.reject_notes = single_user.record.reject_notes
            notesFormik.values.id = single_user.record.id
            notesFormik.values.email = single_user.record.email
        }
    }, [single_user])

    const custom = {
        user_id: {
            value: single_user?.record?.id,
            type: 'in',
            field: 'p.user_id',
        },
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        if (props?.data) {
            toggleFullScreenPopup(false, '', 0)
        } else {
            history.goBack()
        }
    }

    useEffect(() => {
        if (action !== '') {
            getAllDashboardProducts({
                limit: 12,
                page: 1,
                orderby: 'p.date_closed, asc',
                order: '',
                user_id: single_user?.record?.id,
                action: action,
            })
        }
    }, [action])

    useEffect(() => {
        if (
            search_alldashboardproducts &&
            search_alldashboardproducts?.records?.length
        ) {
            let dynamicValueAssign = search_alldashboardproducts
            setTableValue(dynamicValueAssign?.records)
        }
    }, [action])

    return isFullScreen ? (
        <FullScreenPopup
            modaltitle={data.status === 'new' ? 'ADD NEW USER' : 'EDIT USER'}
            open={
                data.status === 'edit' || data.status === 'new'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                setIsLoading(false), toggleFullScreenPopup(false, '', 0)
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            {single_user?.record?.status == 'active' ? null : (
                                <div className="suspendedUserBanner">
                                    <img
                                        src="/assets/images/suspendedUser.png"
                                        alt="Suspended user icon"
                                    />
                                    {single_user?.record?.status ==
                                    'email_unverified' ? (
                                        <h2>
                                            This User&apos;s email hasn&apos;t
                                            been verified yet!
                                        </h2>
                                    ) : (
                                        <h2>
                                            This User has been{' '}
                                            {single_user?.record?.status}!
                                        </h2>
                                    )}
                                </div>
                            )}

                            <div className="customerDetailTabs">
                                <AppBar position="static">
                                    <Tabs
                                        value={value}
                                        // onChange={handleChange}
                                        aria-label="simple tabs example"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        <Tab
                                            label="Profile"
                                            value={0}
                                            onClick={() => handleChange(0)}
                                        />
                                        <Tab
                                            label="Invoices"
                                            value={1}
                                            onClick={() => handleChange(1)}
                                        />
                                        <Tab
                                            label="Notifications"
                                            value={2}
                                            onClick={() => handleChange(2)}
                                        />
                                        <Tab
                                            label="Login Info"
                                            value={3}
                                            onClick={() => handleChange(3)}
                                        />
                                        <Tab
                                            label="Notes"
                                            value={4}
                                            onClick={() => handleChange(4)}
                                        />
                                        <Tab
                                            label="Credits"
                                            value={5}
                                            onClick={() => handleChange(5)}
                                        />
                                        <Tab
                                            label="Mail Logs"
                                            value={6}
                                            onClick={() => handleChange(6)}
                                        />
                                        <Tab
                                            label="SMS Logs"
                                            value={7}
                                            onClick={() => handleChange(7)}
                                        />
                                        <Tab
                                            label="Offer History"
                                            value={8}
                                            onClick={() => handleChange(8)}
                                        />
                                        <Tab
                                            label="Dashboard"
                                            value={9}
                                            onClick={() => handleChange(9)}
                                        />
                                        {/* <Tab
                                        label="Winning Lots"
                                        {...a11yProps(9)}
                                        onClick={() => setAction('winning')}
                                    />
                                    <Tab
                                        label="Outbid Lots"
                                        {...a11yProps(10)}
                                        onClick={() => setAction('outbid')}
                                    />
                                    <Tab
                                        label="Won Lots"
                                        {...a11yProps(11)}
                                        onClick={() => setAction('won')}
                                    /> */}
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={value} index={0}>
                                    <UserManage
                                        data={props.data}
                                        cancelFunction={cancelSubmit}
                                        action={props.action}
                                        userId={props?.match?.params?.id}
                                    />
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    <UserInvoices
                                        userId={single_user?.record?.user_id}
                                    />
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    <UserNotifications
                                        data={single_user?.record}
                                        cancelFunction={cancelSubmit}
                                    />
                                </TabPanel>
                                <TabPanel value={value} index={3}>
                                    <LoginInfo data={single_user?.record} />
                                </TabPanel>
                                <TabPanel value={value} index={4}>
                                    <>
                                        <form
                                            onSubmit={notesFormik.handleSubmit}
                                            autoComplete="nofill"
                                        >
                                            <div className="row">
                                                {mapData(notesField)}
                                            </div>
                                            <PrimaryButton
                                                type="submit"
                                                label="Save"
                                                btnSize="notifBtn"
                                            />
                                        </form>
                                    </>
                                </TabPanel>
                                <TabPanel value={value} index={5}>
                                    <Credits data={single_user?.record} />
                                </TabPanel>
                                <TabPanel value={value} index={6}>
                                    <UserEmailLogs
                                        userId={single_user?.record?.user_id}
                                    />
                                </TabPanel>
                                <TabPanel value={value} index={7}>
                                    <UserSmsLogs
                                        userId={single_user?.record?.user_id}
                                    />
                                </TabPanel>
                                <TabPanel value={value} index={8}>
                                    <UserBidHistory
                                        userId={single_user?.record?.user_id}
                                    />
                                </TabPanel>
                                <TabPanel value={value} index={9}>
                                    <BuyerBids
                                        userId={single_user?.record?.user_id}
                                    />
                                </TabPanel>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    ) : (
        <Layout>
            <div className="addUserModal page">
                <div className="">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <div className="customerDetailTabs">
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    // onChange={handleChange}
                                    aria-label="simple tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label="Profile"
                                        value={0}
                                        onClick={() => handleChange(0)}
                                    />

                                    <Tab
                                        label="Invoices"
                                        value={1}
                                        onClick={() => handleChange(1)}
                                    />

                                    <Tab
                                        label="Notifications"
                                        value={2}
                                        onClick={() => handleChange(2)}
                                    />
                                    <Tab
                                        label="Login Info"
                                        value={3}
                                        onClick={() => handleChange(3)}
                                    />
                                    <Tab
                                        label="Notes"
                                        value={4}
                                        onClick={() => handleChange(4)}
                                    />
                                    <Tab
                                        label="Credits"
                                        value={5}
                                        onClick={() => handleChange(5)}
                                    />
                                    <Tab
                                        label="Mail Logs"
                                        value={6}
                                        onClick={() => handleChange(6)}
                                    />
                                    <Tab
                                        label="SMS Logs"
                                        value={7}
                                        onClick={() => handleChange(7)}
                                    />
                                    <Tab
                                        label="Offer History"
                                        value={8}
                                        onClick={() => handleChange(8)}
                                    />
                                    <Tab
                                        label="Dashboard"
                                        value={9}
                                        onClick={() => handleChange(9)}
                                    />
                                    {/* <Tab
                                        label="Winning Lots"
                                        {...a11yProps(9)}
                                        onClick={() => setAction('winning')}
                                    />
                                    <Tab
                                        label="Outbid Lots"
                                        {...a11yProps(10)}
                                        onClick={() => setAction('outbid')}
                                    />
                                    <Tab
                                        label="Won Lots"
                                        {...a11yProps(11)}
                                        onClick={() => setAction('won')}
                                    /> */}
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                {single_user?.record?.status ==
                                'active' ? null : (
                                    <div className="suspendedUserBanner">
                                        <img
                                            src="/assets/images/suspendedUser.png"
                                            alt="Suspended user icon"
                                        />
                                        {single_user?.record?.status ==
                                        'email_unverified' ? (
                                            <h2>
                                                This User&apos;s email
                                                hasn&apos;t been verified yet!
                                            </h2>
                                        ) : (
                                            <h2>
                                                This User has been{' '}
                                                {single_user?.record?.status}!
                                            </h2>
                                        )}
                                    </div>
                                )}
                                <UserManage
                                    cancelFunction={cancelSubmit}
                                    action={props.action}
                                    userId={props?.match?.params?.id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <UserInvoices
                                    userId={
                                        single_user?.record?.user_id ||
                                        props?.match?.params?.id
                                    }
                                />
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <UserNotifications
                                    data={
                                        single_user?.record || {
                                            user_id: props?.match?.params?.id,
                                            id: props?.match?.params?.id,
                                        }
                                    }
                                    cancelFunction={cancelSubmit}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <LoginInfo
                                    data={
                                        single_user?.record || {
                                            user_id: props?.match?.params?.id,
                                            id: props?.match?.params?.id,
                                        }
                                    }
                                />
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <>
                                    <UserNotes
                                        data={
                                            single_user?.record || {
                                                user_id:
                                                    props?.match?.params?.id,
                                                id: props?.match?.params?.id,
                                            }
                                        }
                                    />
                                    {/* <form
                                        onSubmit={notesFormik.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <div className="row">
                                            {mapData(notesField)}
                                        </div>
                                        <PrimaryButton
                                            type="submit"
                                            label="Save"
                                            btnSize="notifBtn"
                                        />
                                    </form> */}
                                </>
                            </TabPanel>
                            <TabPanel value={value} index={5}>
                                <Credits
                                    data={
                                        single_user?.record || {
                                            user_id: props?.match?.params?.id,
                                            id: props?.match?.params?.id,
                                        }
                                    }
                                />
                            </TabPanel>
                            <TabPanel value={value} index={6}>
                                <UserEmailLogs
                                    userId={
                                        single_user?.record?.user_id ||
                                        props?.match?.params?.id
                                    }
                                />
                            </TabPanel>
                            <TabPanel value={value} index={7}>
                                <UserSmsLogs
                                    userId={
                                        single_user?.record?.user_id ||
                                        props?.match?.params?.id
                                    }
                                />
                            </TabPanel>
                            <TabPanel value={value} index={8}>
                                <UserBidHistory
                                    userId={
                                        single_user?.record?.user_id ||
                                        props?.match?.params?.id
                                    }
                                />
                            </TabPanel>
                            <TabPanel value={value} index={9}>
                                <BuyerBids
                                    userId={
                                        single_user?.record?.user_id ||
                                        props?.match?.params?.id
                                    }
                                />
                            </TabPanel>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    )
}

export default BuyerFields
